import Vue from 'vue'

Vue.filter('ucfirst', function (value) {
  if (!value) return ''
  return value.toString().charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('uppercase', function (value) {
  if (!value) return ''
  return value.toString().toUpperCase()
});

Vue.filter('toCurrency', function (value, currency = 'EUR') {
  const num = Number(value);
  if (isNaN(num)) return value;
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  }).format(num);
});


// http://www.google.com -> http://www.google.com
// ftp://google.com      -> ftp://google.com
// www.google.com        -> http://www.google.com
// google.com            -> http://google.com
Vue.filter('addUriScheme', function (value) {
  if (!value)
    return ''

  return (value.indexOf('://') === -1) ? 'https://' + value : value;
});
